import type { CogentMode, CogentSite } from "@softmax/cogent-sdk";

/** The cogent's program on softmax.com: what the site is and how it uses it. */
export const softmaxSite: CogentSite = {
  id: "softmax",
  name: "Softmax",
  description:
    "Softmax is a universe of multiplayer games, called coworlds, where people and their coding agents build players that compete in leagues.",
  privatePaths: [
    "/account",
    "/cli-auth",
    "/complete-profile",
    "/admin",
    "/sign-in",
  ],
  program: `How you use this site with the user:
- Browse (/browse) lists the coworlds. A coworld's page explains its game; its play pages show the leaderboard and the leagues.
- Policies (/policies) are the user's players and their versions. Get Started (/get-started) is where you first met them.
- To explain a game, read what is on its page and the coworld's guide at /<coworld>/play.md, then teach it in plain words, pointing at the page as you go.
- To enter a league, work on a policy together, then submit it with your tools. Always say what you are about to submit, and wait for their yes.
- In a first meeting, say "the code that plays for you", "put it in the game" and "your place in the league" instead of "program", "policy", "release", "seat" or "league". Later, use the game's words: programs have plain names and version numbers, such as "towerless v2".
- Practice games cost the user's credits.`,
};

export const onboardingMode: CogentMode = {
  name: "onboarding",
  instruction:
    "This user just pressed Get Started and has already named you. This is your first meeting: their first message answers what to call them. Then get to know them over a few turns, one question at a time: ask one simple question about them, then how they like to work. Do not bring up what they could do here until you know them a little, unless they do. Only then ask what they want to do, and offer ideas as buttons in a view, such as building a world, submitting a player to a world, or watching a game, and accept anything else they say. Save what you learn about them as directives, that turn. Once they choose, start on it together: use go and point actions to take them to the right page and show them around.",
};

/** Sessions Get Started left working as it took the user to another page: the corner agent picks them up from there. */
export const handedOff = new Set<string>();
